import { sfwUrl } from "./env";
import { routes } from "@/common/utils/routes";

interface GeoRule {
  readonly allowedPages: string[];
  readonly redirectTo: string;
}

export const COMMON_ALLOWED_PAGES = [
  "/auth/signin",
  "/guidelines",
  "/ifr/",
  "/user/verify",
];

const blockedStates = [
  "alabama",
  "florida",
  "indiana",
  "kansas",
  "louisiana",
  "oklahoma",
  "south dakota",
  "tennessee",
  "texas",
];

const blockedCountries = [
  "GB"
];

export const STATE_RULES = new Map<string, GeoRule>();
const COUNTRY_RULES = new Map<string, GeoRule>();

blockedStates.forEach(state => {
  const pageState = routes.geoBlockedPage(state.replace(" ", "-"));

  STATE_RULES.set(state, {
    allowedPages: [pageState, ...COMMON_ALLOWED_PAGES],
    redirectTo: pageState,
  });
});

blockedCountries.forEach(country => {
  COUNTRY_RULES.set(country, {
    allowedPages: [...COMMON_ALLOWED_PAGES],
    redirectTo: sfwUrl,
  });
});

export const getRule = (country?: string | null, blockedState?: string | null) => {
  return (blockedState && STATE_RULES.get(blockedState)) || (country && COUNTRY_RULES.get(country));
};

export const isPageAllowed = (pathname: string, allowed: string[]) =>
  allowed.some((page) => pathname.startsWith(page));
